import Vue from 'vue'

Vue.prototype.$apiRouter = {

  landingRates: '/v1/landing-rates',
  /* Auth Api v1 */
  registration: '/v1/register',
  login: '/v1/login',
  refresh: '/v1/refresh',
  forgotPassword: '/v1/forgot-password',
  changePassword: '/v1/reset-password',
  verifyEmail: '/v1/verify',
  logout: '/v1/logout',
  tracking: '/v1/tracking',
  trackingUser: '/v1/order/tracking',
  confirmSms: '/v1/sms/verify',
  resendSms: '/v1/sms/resend',
  settings: '/v1/settings',

  /* Duties */
  checkDuty: '/v1/checkDuty',

  /* User */
  me: '/v1/user',
  editPasswordUser: '/v1/user/change-password',
  paymentProfile: '/v1/user/payment-profile/',
  setupPayPal: '/v1/user/setup-paypal',
  savePayPal: '/v1/user/save-paypal/',
  deletePayPal: '/v1/user/delete-paypal',
  pointsHistory: '/v1/user/points-history',

  /* Orders */
  order: '/v1/order',
  orderDuplicate: '/v1/order/duplicate/',
  shop: '/v1/shop',
  orderCompleted: '/v1/order?tab=completed',
  uploadPdf: '/v1/order/commercial-invoice',
  removePdf: '/v1/order/commercial-invoice/',
  createOrder: '/v1/order/create',
  uploadImg: '/v1/order/item-photo',
  removeImg: '/v1/order/item-photo/',
  orderView: '/v1/order/',
  orderDelete: '/v1/order/',
  group: '/v1/group/',
  groupOrder: '/v1/group/order/',
  paymentGroup: '/v1/group/payment/',
  setDelivered: '/v1/order/set-delivered/',
  setAdditionPhoto: '/v1/order/set-send-addition-photo',
  requestRepack: '/v1/order/request-repack/',
  requestReturn: '/v1/order-return',
  cancelReturn: '/v1/order-cancel-return',
  deleteRequestRepack: '/v1/order/delete-request-repack/',
  shipOptions: '/v1/order/goshippo-create/',
  getLabel: '/v1/order/pdf-label/',

  // Split order
  splitOrderList: '/v1/order-split/',
  orderForSecondStep: '/v1/order-split/',
  setSplitOrder: '/v1/order-split/',
  /* End orders */

  /* Address */
  address: '/v1/address-book',
  getAddress: '/v1/address-book/',
  removeAddress: '/v1/address-book/',
  updateAddress: '/v1/address-book/',
  country: '/v1/country',
  city: '/v1/city',
  district: '/v1/district',
  subdistrict: '/v1/sub-district',
  koreanAddress: '/v1/korean-address',
  mnRegion: '/v1/get-mn-region/',
  getZipCode: '/v1/get-zip/',
  /* End address */

  /* Department */
  departments: '/v1/departments',
  /* End department */

  /* Invoice */
  invoice: '/v1/invoice',
  invoiceView: '/v1/invoice/',
  invoicePdf: '/v1/invoice/pdf/',
  invoiceCompleted: '/v1/invoice?tab=completed',
  nonPasswordInvoiceView: '/v1/invoice-pay/',
  unauthorizedPaymentByPayPal: '/v1/unauthorized-payment/paypal/',
  unauthorizedPaymentByAuthorize: '/v1/unauthorized-payment/authorize/',
  invoiceOptions: '/v1/invoice/amounts',

  /* Payment */
  payByPoints: "/v1/payment/pay-by-points/",
  payByPayPal: "/v1/payment/pay-pal/",
  payByAuthorize: "/v1/payment/authorize/",
  payCashOnDelivery: "/v1/payment/collect/",
  payByBitPay: "/v1/payment/bit-pay/",

  /* Buy Point */
  buyPoint: {
    payByPayPal: "/v1/payment/point/pay-pal/",
    payByBitPay: "/v1/payment/point/bit-pay/",
    payByAuthorize: "/v1/payment/point/authorize/",
  },

  /* Product types */
  productTypes: '/v1/product-types',

  /* Self-serves */
  ssLogin: '/selfServes/web_login',
  ssLogout: '/selfServes/web_logout',
  ssVerify: '/selfServes/web_verify',
  ssResend: '/selfServes/web_resend',
  ssRefresh: '/selfServes/web_refresh',
  ssGetShipper: '/selfServes/web_getShipper',
  ssCountry: '/selfServes/web_getAllCountries',
  ssMnCities: '/selfServes/web_getMnCities',
  ssMnDistricts: '/selfServes/web_getDistrictsByCity',
  ssMnSubDistricts: '/selfServes/web_getSubDistrictsByDistrict',
  ssProductTypes: '/selfServes/web_getAllProductType',
  ssCheckDuty: '/selfServes/web_checkDutyForOrder',
  ssCheckDepartment: '/selfServes/web_checkDepartment',
  ssPaymentList: '/selfServes/web_getPaymentMethodList',
  ssTermsCondition: '/selfServes/web_getTermsCondition',
  ssCreateOrder: '/selfServes/web_createOrders',
  ssDestinationDepartment: '/selfServes/web_getDestinationDepartmentWithDetails',
  ssGetSettingValue: '/selfServes/web_getSettingValue',
  ssGetDepartments: '/selfServes/web_getDepartments',
  ssCheckEmailPresence: '/selfServes/checkEmailPresence',
  ssSendConfirmChangePhoneNumber: '/selfServes/sendConfirmChangePhoneNumber',

  /* Static Page Api v1 */

  /* Admin */

  /* Orders */
  adminOrder: '/admin/order',
  countWithoutShipping: '/admin/order/count-without-shipping',
  listWithoutShipping: '/admin/order/list-without-shipping',
  countNotPaidMoreThanMonth: '/admin/order/count-not-paid-more-than-month',
  listNotPaidMoreThanMonth: '/admin/order/list-not-paid-more-than-month',
  adminOrderView: '/admin/order/view/',
  adminOrderViewHistory: '/admin/order/view-history/',
  adminUpdateOrder: '/admin/order/update',
  adminOrderChangeStatus: '/admin/order/change-status',
  adminOrderChangeWasPrinted: '/admin/order/change-was-printed',
  adminOrderChangeLabelColor: '/admin/order/change-label-color',
  adminOrderUndoDelete: '/admin/order/undo-delete/',
  adminOrderRepack: '/admin/order/request-repack/',
  adminRequestForProcessing: '/admin/order/request-for-processing',
  adminOrderAttachments: '/admin/order/attachments',
  adminOrderRequestReturn: '/admin/order/request-return',
  adminOrderCancelReturn: '/admin/order/cancel-return',
  adminOrderDuplicate: '/admin/order/duplicate/',
  adminReportsFlight: '/admin/reports/flight',
  adminReportsBag: '/admin/reports/bag',
  adminReportsSelfServe: '/admin/reports/self-serve',
  adminReportsDelivery: '/admin/reports/delivery',
  adminReportsWalkin: '/admin/reports/walkin',
  adminReportsShelvesHistory: '/admin/reports/shelves-history',
  adminReportsSummary: '/admin/reports/summary',
  adminCombinedOrders: '/admin/order/groups',
  adminCombinedOrdersGroup: '/admin/order/groups/orders',
  adminCombinedOrdersOrder: '/admin/order/groups/order',
  adminCombinedOrdersForCombine: '/admin/order/groups/orders',
  adminCombinedOrdersLabelColor: '/admin/order/groups/set-label-color',
  adminOrderSplit: '/admin/order/split',

  /* Invoices */
  adminInvoice: '/admin/invoice',
  countUnpaidInvoices: '/admin/invoice/count-unpaid-invoices',
  listUnpaidInvoices: '/admin/invoice/list-unpaid-invoices',

  /* Users */
  adminUser: '/admin/user',
  adminUpdateShipper: '/admin/user/update-shipper/',
  adminSearchByMailbox: '/admin/user/search-by-mailbox',
  adminAddressBook: '/admin/user/address-book',

  /* Reports */
  adminReportsSalesDepartments: '/admin/reports/sales-departments',
  adminReportsProcessesStockroom: '/admin/reports/processes-stockroom',
  adminReportsTotalPayments: '/admin/reports/payments-by-type',
  adminOverdueOrderedOrders: '/admin/reports/old-ordered-orders',

  /* Payments */
  adminPayByPoints: '/admin/payment/pay-by-points/',
  adminPayByPayPal: '/admin/payment/pay-pal/',
  adminPayByAuthorize: '/admin/payment/authorize/',

  /* Product type */
  productType: '/admin/product-type',

  /* Settings */
  adminCurrency: '/admin/currency',
  adminSettings: '/admin/settings',
  adminFaq: '/admin/settings/faq',
  adminDO: '/admin/settings/shipment-option',
  messengerTranslations: '/admin/settings/translations/messenger-translations',
  translationsDataFilter: '/admin/settings/translations/data-for-filter',
  adminSettingsEmailTemplate: '/admin/settings/email-template',
  adminSettingsTranslation: '/admin/settings/translations',
  adminSettingsTermsAndConditions: '/admin/settings/tc',
  adminSettingsManageAnnouncement: '/admin/settings/manage-announcement',
  adminSettingsInvoicesText: '/admin/settings/merchandise-invoice-text',
  adminSettingsDepartments: '/admin/settings/department',
  adminSettingsDepartmentsRates: '/admin/settings/department-rate',
  adminSettingsPaymentMethods: '/admin/settings/payments-method',
  adminSettingsWebSiteAddresses: '/admin/settings/website-address',
  adminSettingsDuty: '/admin/settings/duty',
  adminSettingsCustomCharges: '/admin/settings/custom-charge',
  adminSettingsSelfServeQr: '/admin/settings/self_serve_qr',
  adminSettingsDeliveryPrice: '/admin/settings/delivery-price',
  adminSettingsDeliveryPriceCities: '/v1/city',
  adminSettingsDeliveryPriceDistricts: '/v1/district',
  adminSettingsDeliveryPriceSubDistricts: '/v1/sub-district',
  adminSettingsExchangeRates: '/admin/settings/exchange-rate',
}
